import * as wf from "client-api-workflow";
import { clearElementCache } from "qpr-base/querybuilder/ElementCache";
import React from "react";
import { useMutation, useQueryClient } from "react-query";

const useStartElementWorkflow = () => {
  const queryClient = useQueryClient();
  const invalidateCache = React.useMemo(
    () => ({
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey.indexOf("data-") >= 0,
        });
      },
    }),
    [queryClient]
  );
  return useMutation(
    async (data: {
      configName: string;
      period: string;
      elementIds: string[];
    }) => {
      const list = await wf.createWFTestIntances({
        clearPrevious: "false",
        configName: data.configName,
        period: data.period,
        query: `[${data.elementIds.join(",")}]`,
      });
      clearElementCache(data.elementIds || []);
      console.log("createWFTestIntances ", list);
    },
    invalidateCache
  );
};

export default useStartElementWorkflow;
